import { CommonModule } from '@angular/common'
import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges, inject, signal } from '@angular/core'
import { PalantirContentComponent, PalantirIconComponent, PalantirLabelColorsEnum, PalantirTagComponent, PalantirTextComponent } from '@fieldcontrol/palantir'
import { Warranty } from '@generated/sammathnaur.graphql'
import { TranslateService } from '@ngx-translate/core'
import { PipesModule } from 'projects/fce-components/src/app/core/pipes/pipes.module'
import { expandCollapseSignerCard } from './accordion.animation'

@Component({
    selector: 'palantir-accordion',
    imports: [
        CommonModule,
        PalantirContentComponent,
        PalantirTextComponent,
        PalantirIconComponent,
        PalantirTagComponent,
        PipesModule
    ],
    templateUrl: './accordion.component.html',
    styleUrls: ['./accordion.component.scss'],
    animations: [expandCollapseSignerCard]
})
export class PalantirAccordionComponent implements OnInit, OnChanges {
  @Input({ required: true }) public warranty!: Warranty
  @Input() public open?: boolean = true
  @Output() public readonly toggle = new EventEmitter<boolean>()

  private translateService = inject(TranslateService)
  public isOpen = signal(false)
  public tag = signal<({ color: PalantirLabelColorsEnum, label: string })>(this.mapperTag())

  public ngOnInit(): void {
    this.tag.set(this.mapperTag())
    if (this.open !== undefined) {
      this.isOpen.set(this.open)
    }
  }

  public ngOnChanges(changes: SimpleChanges): void {
    if (changes['open']) {
      this.isOpen.set(changes['open'].currentValue)
    }
  }

  public toggleOpen(): void {
    this.isOpen.update((isOpen) => !isOpen)
    this.toggle.emit(this.isOpen())
  }

  public mapperTag() {
    const statusColor = {
      active: 'active',
      expired: 'expired',
      extended: 'extended',
      future: 'future',
      default: 'grey',
    }

    const status = this.warranty?.status ?? 'default'
    return {
      color: statusColor[status] as PalantirLabelColorsEnum,
      label: this.translateService.instant(`TAB_WARRANTIES_EQUIPMENT.DIALOG.STATUS.${status.toUpperCase()}`)
    }
  }
}
